import React from 'react'
import { MerchantCategoriesLoader, LoaderSwitcher } from 'router/Loaders'
import ProductsAndModifiers from 'components/ProductsAndModifiers'

export const ProductsAndModifiersWrapper = () => {
  return (
    <MerchantCategoriesLoader>
      {(isParentLoaded) => (
        <LoaderSwitcher isParentLoaded={isParentLoaded}>
          <ProductsAndModifiers />
        </LoaderSwitcher>
      )}
    </MerchantCategoriesLoader>
  )
}
